import { createTheme } from '@mui/material';
import colors from './colors';

const theme = createTheme({
    direction: 'rtl',
    palette: {
        primary: {
            light: '#33B8E8',
            main: colors.theme.yaelGreen,
            dark: colors.theme.yaelDark,
            contrastText: '#ffffff',
        },
        secondary: {
            main: colors.theme.yaelOrange,
            contrastText: '#ffffff',
        },
    },
    typography: {
        fontFamily: '"Rubik", "Helvetica", "Arial", "sans-serif"'
    },
    components: {
        MuiCircularProgress: {
            styleOverrides: {
                root: {
                    color: colors.theme.yaelGreen,
                },
            },
        },
    },
});

export default theme;
